import { Box, Paper } from "@mui/material";
import { ExportDataButton } from "components/ExportDataButton";
import { OmnisearchDataGrid } from "components/OmnisearchDataGrid";
import {
  CredentialImplementationsForStaffQuery,
  CredentialImplementationsForStaffQueryVariables,
} from "generated-graphql/graphql";
import { useCallback } from "react";

import { CREDENTIAL_IMPLEMENTATIONS_FOR_STAFF_QUERY } from "./api";
import { COLUMNS, type Row } from "./columns";

const EXPORT_SORT = [{ field: "state", sort: "asc" }] as const;

export function EpcraCredentialManagement() {
  const getItems = useCallback(
    (data: CredentialImplementationsForStaffQuery) => data.credentialImplementationsForStaff.items,
    []
  );

  const getCount = useCallback(
    (data: CredentialImplementationsForStaffQuery) => data.credentialImplementationsForStaff.count,
    []
  );

  const commandButtons = useCallback(
    ({ search }: { search: string }) => [
      <ExportDataButton
        key="export"
        exportType="credentialImplementationsForStaff"
        fileName="epcra-credential-management"
        filter={{ search: search || undefined, sort: EXPORT_SORT }}
      />,
    ],
    []
  );

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <Box
        sx={{
          height: "100vh",
          pt: 3,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <OmnisearchDataGrid<
          CredentialImplementationsForStaffQuery,
          CredentialImplementationsForStaffQueryVariables,
          Row
        >
          isURLDriven
          persistenceKey="epcra-credential-management-v1"
          columns={COLUMNS}
          commandButtons={commandButtons}
          dataQuery={CREDENTIAL_IMPLEMENTATIONS_FOR_STAFF_QUERY}
          initialSortModel={[{ field: "state", sort: "asc" }]}
          getItems={getItems}
          getCount={getCount}
          noDataMessage="No credential implementations found."
          initialPageSize={50}
          wideLayout
          debounceMs={800}
          fetchPolicy="network-only"
          gridSx={{
            height: "100%",
            minHeight: "400px",
            maxHeight: "calc(100vh - 280px)",
          }}
        />
      </Box>
    </Paper>
  );
}
